var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFlagsJpyEur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    rx: 1,
    fill: "#003399"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 2.40002L10.1652 2.89658H10.6999L10.2673 3.20347L10.4326 3.70002L9.99993 3.39314L9.5673 3.70002L9.73255 3.20347L9.29993 2.89658H9.83468L9.99993 2.40002Z",
    fill: "#FFCB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15996 4.61005L6.32521 5.1066H6.85996L6.42734 5.41349L6.59258 5.91005L6.15996 5.60316L5.72734 5.91005L5.89258 5.41349L5.45996 5.1066H5.99471L6.15996 4.61005Z",
    fill: "#FFCB00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77996 2.98004L7.9452 3.4766H8.47996L8.04733 3.78349L8.21258 4.28004L7.77996 3.97315L7.34733 4.28004L7.51258 3.78349L7.07996 3.4766H7.61471L7.77996 2.98004Z",
    fill: "#FFCB00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8499 4.59003L14.0151 5.08658H14.5499L14.1173 5.39347L14.2825 5.89003L13.8499 5.58314L13.4173 5.89003L13.5825 5.39347L13.1499 5.08658H13.6847L13.8499 4.59003Z",
    fill: "#FFCB00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.22 2.99005L12.3853 3.48661H12.92L12.4874 3.7935L12.6526 4.29005L12.22 3.98316L11.7874 4.29005L11.9526 3.7935L11.52 3.48661H12.0548L12.22 2.99005Z",
    fill: "#FFCB00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.46 6.83008L14.6253 7.32663H15.16L14.7274 7.63352L14.8926 8.13008L14.46 7.82319L14.0274 8.13008L14.1926 7.63352L13.76 7.32663H14.2948L14.46 6.83008Z",
    fill: "#FFCB00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 11.28L10.1652 11.7766H10.6999L10.2673 12.0835L10.4326 12.58L9.99993 12.2731L9.5673 12.58L9.73255 12.0835L9.29993 11.7766H9.83468L9.99993 11.28Z",
    fill: "#FFCB00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76995 10.6901L7.93519 11.1866H8.46995L8.03732 11.4935L8.20257 11.9901L7.76995 11.6832L7.33732 11.9901L7.50257 11.4935L7.06995 11.1866H7.6047L7.76995 10.6901Z",
    fill: "#FFCB00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14995 9.05005L6.3152 9.5466H6.84995L6.41733 9.85349L6.58257 10.35L6.14995 10.0432L5.71733 10.35L5.88257 9.85349L5.44995 9.5466H5.9847L6.14995 9.05005Z",
    fill: "#FFCB00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54998 6.83008L5.71522 7.32663H6.24998L5.81735 7.63352L5.9826 8.13008L5.54998 7.82319L5.11735 8.13008L5.2826 7.63352L4.84998 7.32663H5.38473L5.54998 6.83008Z",
    fill: "#FFCB00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8499 9.05005L14.0151 9.5466H14.5499L14.1173 9.85349L14.2825 10.35L13.8499 10.0432L13.4173 10.35L13.5825 9.85349L13.1499 9.5466H13.6847L13.8499 9.05005Z",
    fill: "#FFCB00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.22 10.6801L12.3853 11.1766H12.92L12.4874 11.4835L12.6526 11.9801L12.22 11.6732L11.7874 11.9801L11.9526 11.4835L11.52 11.1766H12.0548L12.22 10.6801Z",
    fill: "#FFCB00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4444_49430)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 23.1667C24 23.6271 23.6271 24 23.1667 24H4.83333C4.37292 24 4 23.6271 4 23.1667V9.83333C4 9.37292 4.37292 9 4.83333 9H23.1667C23.6271 9 24 9.37292 24 9.83333V23.1667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12.3333C16.3013 12.3333 18.1667 14.1987 18.1667 16.5C18.1667 18.8012 16.3013 20.6667 14 20.6667C11.6988 20.6667 9.83337 18.8012 9.83337 16.5C9.83337 14.1987 11.6988 12.3333 14 12.3333Z",
    fill: "#BA0831"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4444_49430",
    x: 0,
    y: 5,
    width: 28,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.168627 0 0 0 0 0.188235 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4444_49430"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4444_49430",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlagsJpyEur);
export default __webpack_public_path__ + "static/media/ic_flags_jpy_eur.379d76b3.svg";
export { ForwardRef as ReactComponent };